import React from "react";

import { Button } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

import { LineInput } from "components/Inputs/LineInput";
import AibleStep from "containers/CreateWizard/AibleStep";

import CostsSlider from "containers/CreateWizard/Costs/CostsSlider";

import styles from "./style.module.css";

export default class RawCosts extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { isSimple: false };
  }

  renderCostsCheck() {
    const { hideCosts, updateHideCosts } = this.props;

    return (
      <div className={styles.costsCheck} onClick={() => updateHideCosts(!hideCosts)}>
        <input type="checkbox" checked={!hideCosts} onChange={() => {}} />
        {"Include soft benefits and costs"}
      </div>
    );
  }

  renderNormal(isRender) {
    const {
      id,
      conversionGain,
      conversionCost,
      conversionSaved,
      conversionMissed,
      blueprintId,
      customValues,
      currentROI,
      convergeError,
      truePositive,
      falsePositive,
      trueNegative,
      falseNegative,
      truePositiveLabel,
      falsePositiveLabel,
      trueNegativeLabel,
      falseNegativeLabel,
      netImpactLabel,
      isShow,
      isAdvanced,
      hideCosts,
      outcome,
      options,
      success,
      priceColumn,
      successOptions,
      updateFalsePositive,
      updateTruePositive,
      updateTrueNegative,
      updateFalseNegative,
      updateFalsePositiveLabel,
      updateTruePositiveLabel,
      updateTrueNegativeLabel,
      updateFalseNegativeLabel,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateIsAdvanced,
      updateNetImpactLabel,
      isAcademicResultsCard,
      noEdit
    } = this.props;

    const waterfallBars = hideCosts
      ? [
          {
            label: truePositiveLabel,
            value: conversionGain
          },
          {
            label: falsePositiveLabel,
            value: conversionCost
          }
        ]
      : [
          {
            label: truePositiveLabel,
            value: conversionGain
          },
          {
            label: falsePositiveLabel,
            value: conversionCost
          },
          {
            label: trueNegativeLabel,
            value: conversionSaved
          },
          {
            label: falseNegativeLabel,
            value: conversionMissed
          }
        ];

    const negOutcomes = successOptions.filter((s) => s.value !== success);

    const isLocked = options && options["lock"];

    return (
      <div>
        <div className={styles.holderR}>
          <div className={styles.outerCosts}>
            <div className={styles.positiveImpacts}>
              <div className={styles.impactHeader + " " + (isAcademicResultsCard ? styles.impactHeaderAcad : "")}>
                <div className={styles.positiveIcon}>
                  <FontAwesomeIcon icon={faArrowUp} />
                </div>
                {"Positive Impacts"}
              </div>
              <div className={styles.costType}>
                <div className={styles.rowLabelR}>
                  <div className={styles.topImpact} id="truePositiveLabel">
                    <LineInput
                      value={truePositiveLabel}
                      onChange={(val) => updateTruePositiveLabel(val)}
                      isMediumBox
                      isLocked={isLocked}
                      isDisabled={noEdit}
                    />
                  </div>
                  <div className={styles.botLabel} title={"Correctly Predict " + success}>
                    {"Correctly Predict "}
                    <span className={styles.bold}>{success}</span>
                  </div>
                </div>
                <div className={styles.impactInput} id="truePositiveImpact">
                  <LineInput
                    inputType="float"
                    value={conversionGain}
                    onChange={(val) => updateConversionGain(val)}
                    borderColor={waterfallBars[0].color}
                    isLocked={isLocked}
                    isDisabled={noEdit}
                    isMediumBox
                  />
                </div>
              </div>
              <div className={styles.costType}>
                <div className={styles.rowLabelR}>
                  <div className={styles.topImpact} id="trueNegativeLabel">
                    <LineInput
                      value={trueNegativeLabel}
                      onChange={(val) => updateTrueNegativeLabel(val)}
                      isMediumBox
                      isLocked={isLocked}
                      isDisabled={noEdit}
                    />
                  </div>
                  <div
                    className={styles.botLabel}
                    title={
                      "Correctly Predict " +
                      negOutcomes.map((o, i) => o.value + (i < negOutcomes.length - 1 ? ", " : ""))
                    }
                  >
                    {"Correctly Predict "}
                    <span className={styles.bold}>
                      {negOutcomes.map((o, i) => o.value + (i < negOutcomes.length - 1 ? ", " : ""))}
                    </span>
                  </div>
                </div>
                <div className={styles.impactInput} id="trueNegativeImpact">
                  <LineInput
                    inputType="float"
                    value={conversionSaved}
                    onChange={(val) => updateConversionSaved(val)}
                    borderColor={waterfallBars[hideCosts ? 0 : 2].color}
                    isMediumBox
                    isLocked={isLocked}
                    isDisabled={noEdit}
                  />
                </div>
              </div>
            </div>
            <div className={styles.negativeImpacts}>
              <div className={styles.impactHeader + " " + (isAcademicResultsCard ? styles.impactHeaderAcad : "")}>
                <div className={styles.negativeIcon}>
                  <FontAwesomeIcon icon={faArrowDown} />
                </div>
                {"Negative Impacts"}
              </div>
              <div className={styles.costType}>
                <div className={styles.rowLabelR}>
                  <div className={styles.topImpact} id="falsePositiveLabel">
                    <LineInput
                      value={falsePositiveLabel}
                      onChange={(val) => updateFalsePositiveLabel(val)}
                      isLocked={isLocked}
                      isDisabled={noEdit}
                      isMediumBox
                    />
                  </div>
                  <div className={styles.botLabel} title={"Incorrectly Predict " + success}>
                    {"Incorrectly Predict "}
                    <span className={styles.bold}>{success}</span>
                  </div>
                </div>
                <div className={styles.impactInput} id="falsePositiveImpact">
                  <LineInput
                    inputType="float"
                    value={conversionCost}
                    onChange={(val) => updateConversionCost(val)}
                    borderColor={waterfallBars[1].color}
                    isLocked={isLocked}
                    isDisabled={noEdit}
                    isMediumBox
                  />
                </div>
              </div>
              <div className={styles.costType}>
                <div className={styles.rowLabelR}>
                  <div className={styles.topImpact} id="falseNegativeLabel">
                    <LineInput
                      value={falseNegativeLabel}
                      onChange={(val) => updateFalseNegativeLabel(val)}
                      isMediumBox
                      isLocked={isLocked}
                      isDisabled={noEdit}
                    />
                  </div>
                  <div
                    className={styles.botLabel}
                    title={
                      "Incorrectly Predict " +
                      negOutcomes.map((o, i) => o.value + (i < negOutcomes.length - 1 ? ", " : ""))
                    }
                  >
                    {"Incorrectly Predict "}
                    <span className={styles.bold}>
                      {negOutcomes.map((o, i) => o.value + (i < negOutcomes.length - 1 ? ", " : ""))}
                    </span>
                  </div>
                </div>
                <div className={styles.impactInput} id="falseNegativeImpact">
                  <LineInput
                    inputType="float"
                    value={conversionMissed}
                    onChange={(val) => updateConversionMissed(val)}
                    borderColor={waterfallBars[hideCosts ? 0 : 3].color}
                    isMediumBox
                    isLocked={isLocked}
                    isDisabled={noEdit}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {priceColumn && (
          <div className={styles.botLabel}>
            {"The impacts are being scaled by " +
              priceColumn +
              ". You will be able to change this in your dataset settings"}
          </div>
        )}
        {convergeError && <div className={styles.convergeError}>{convergeError}</div>}
      </div>
    );
  }

  render() {
    const {
      id,
      conversionGain,
      conversionCost,
      conversionSaved,
      conversionMissed,
      blueprintId,
      customValues,
      currentROI,
      convergeError,
      customFields,
      truePositive,
      falsePositive,
      trueNegative,
      falseNegative,
      truePositiveLabel,
      falsePositiveLabel,
      trueNegativeLabel,
      falseNegativeLabel,
      netImpactLabel,
      isShow,
      isSimpleCosts,
      isAdvanced,
      isEditing,
      hideCosts,
      outcome,
      success,
      successOptions,
      updateFalsePositive,
      updateTruePositive,
      updateTrueNegative,
      updateFalseNegative,
      updateFalsePositiveLabel,
      updateTruePositiveLabel,
      updateTrueNegativeLabel,
      updateFalseNegativeLabel,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateIsAdvanced,
      updateIsSimpleCosts,
      updateNetImpactLabel,
      hideExtra
    } = this.props;

    const negOutcomes = successOptions.filter((s) => s.value !== success);

    return (
      <div>
        {isSimpleCosts === true ? (
          <CostsSlider id={id} blueprintId={blueprintId} />
        ) : (
          <div className={styles.body}>
            {hideExtra !== true && (
              <AibleStep
                id={id}
                bId={"rawCosts"}
                message={"What are the impacts of the AI correctly or incorrectly predicting the outcome?"}
                secondaryMessage={"(Hint: Enter a '-' if the impact is negative)"}
                isBreak={true}
                optionsHolder={false}
              />
            )}
            {this.renderNormal()}
          </div>
        )}
        {hideExtra !== true && (
          <div className={styles.advancedBtn}>
            <Button type="secondary" onClick={() => updateIsSimpleCosts(!isSimpleCosts)}>
              {isSimpleCosts ? "Show Advanced" : "I Don't Know"}
            </Button>
          </div>
        )}
      </div>
    );
  }
}
